import Nickname from './Nickname';

export default Nickname;
